<template>
  <div class="home">
      <gheader></gheader>
      <gnavigation></gnavigation>
      <div class="main_content">
        <router-view></router-view>
      </div>
      <gfooter class="gfooter"></gfooter>
  </div>
</template>

<script>
import gheader from "@/components/header.vue"
import gnavigation from "@/components/navigation.vue"
import gfooter from "@/components/gfooter.vue"
export default {
  name: 'HomeView',
  components: {
    gheader,
    gnavigation,
    gfooter
  }
}
</script>

<style lang="scss" scoped>



  .home{
    background-color:#F3F3F3 ;


    display: flex;
    flex-direction: column;
  }
</style>
